// extracted by mini-css-extract-plugin
module.exports = {"Inputs":"Tag_Inputs__6EDyZ","Tag":"Tag_Tag__3WiMe","fadeIn":"Tag_fadeIn__3FEDt","modalFadeIn":"Tag_modalFadeIn__Gk42o","slideInFromRight":"Tag_slideInFromRight__3qGY9"};